export enum InsuranceStatus {
  Yes = "YES",
  No = "NO",
}

export enum InfoQuestionType {
  OptionList = "OPTION_LIST",
  FreeText = "FREE_TEXT",
  Number = "NUMBER",
  Date = "DATE",
}
